import React from "react";
import styles from "../../Tax.module.scss";

const LoadingSpinner = ({ size = "medium", text = "", overlay = false }) => {
  if (overlay) {
    return (
      <div className={styles.loadingOverlay}>
        <div
          className={
            size === "large"
              ? styles.loadingSpinnerLarge
              : styles.loadingSpinner
          }
        />
        {text && <span>{text}</span>}
      </div>
    );
  }

  return (
    <div
      style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem" }}
    >
      <div
        className={
          size === "large" ? styles.loadingSpinnerLarge : styles.loadingSpinner
        }
      />
      {text && (
        <span style={{ fontSize: "0.875rem", color: "#4a5568" }}>{text}</span>
      )}
    </div>
  );
};

export default React.memo(LoadingSpinner);
